import React, { useState, useEffect } from 'react';
import { useStockModal } from '../context/StockModalContext';
import { api } from '../services/apiClient'; // IMPORT API
import { Plus, Folder, Search, ShoppingCart, Activity, X, FolderPlus, ArrowUpRight, ArrowDownRight, ArrowRightLeft, Edit2, Trash2, Star, DollarSign, Crown } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'; // IMPORT LINK

const WatchlistPage = () => {
  const { t } = useTranslation();
  const [watchlists, setWatchlists] = useState([]); 
  const [activeListId, setActiveListId] = useState(null); 
  const [items, setItems] = useState([]); 
  
  const [loading, setLoading] = useState(true);
  const [loadingItems, setLoadingItems] = useState(false);
  const [isProUser, setIsProUser] = useState(false); // NOUVEAU
  
  const [modalType, setModalType] = useState(null);
  const [newListTitle, setNewListTitle] = useState('');
  const [newItemSymbol, setNewItemSymbol] = useState('');
  
  const [selectedSymbol, setSelectedSymbol] = useState(null);
  const [targetListId, setTargetListId] = useState('');
  const [portfolios, setPortfolios] = useState([]);
  
  const [buyForm, setBuyForm] = useState({ portfolio_id: '', quantity: '', price: '', commission: 0, currency: 'USD', date: '', time: '', notes: '' });

  const { openStockModal } = useStockModal();

  const safeVal = (val) => val || 0;

  useEffect(() => { 
      fetchWatchlists(); 
      fetchPortfolios(); 
      checkProStatus();
  }, []);

  useEffect(() => { if (activeListId) fetchListItems(activeListId); }, [activeListId]);

  const checkProStatus = async () => {
       try {
          const token = localStorage.getItem('token');
          if (token) {
              const userRes = await api.get('/auth/me');
              setIsProUser(userRes.data.is_pro);
          }
      } catch (error) {
          console.error("Erreur Auth:", error);
      }
  };

  const fetchWatchlists = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch('/api/watchlist/', { headers: { 'Authorization': `Bearer ${token}` } });
      if (res.ok) {
        const data = await res.json();
        setWatchlists(data);
        if (data.length > 0 && !activeListId) setActiveListId(data[0].id);
        else if (data.length === 0) setItems([]);
      }
    } catch (err) {} 
    finally { setLoading(false); }
  };

  const fetchListItems = async (listId) => {
    setLoadingItems(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`/api/watchlist/${listId}`, { headers: { 'Authorization': `Bearer ${token}` } });
      if (res.ok) { const data = await res.json(); setItems(data.items || []); }
    } catch (err) {} 
    finally { setLoadingItems(false); }
  };

  const fetchPortfolios = async () => {
      const tok = localStorage.getItem('token');
      const r = await fetch('/api/portfolio/', { headers: { 'Authorization': `Bearer ${tok}` } });
      if(r.ok) {
          const data = await r.json(); setPortfolios(data);
          if (data.length > 0) setBuyForm(prev => ({...prev, portfolio_id: data[0].id}));
      }
  };

  const handleCreateListClick = () => {
      if (!isProUser && watchlists.length >= 1) {
          alert("Version Gratuite : Vous êtes limité à 1 seule Watchlist. Passez PRO pour créer des dossiers illimités !");
          // Optionnel : Vous pourriez ouvrir une jolie modale "Passer Pro" ici
          return;
      }
      setNewListTitle(''); 
      setModalType('CREATE_LIST');
  };

  const handleCreateList = async (e) => { e.preventDefault(); const tok = localStorage.getItem('token'); const res = await fetch('/api/watchlist/', { method: 'POST', headers: {'Content-Type':'application/json', 'Authorization': `Bearer ${tok}`}, body: JSON.stringify({ name: newListTitle }) }); if (res.ok) { setNewListTitle(''); setModalType(null); await fetchWatchlists(); } };
  const handleRenameList = async (e) => { e.preventDefault(); const tok = localStorage.getItem('token'); const res = await fetch(`/api/watchlist/${activeListId}`, { method: 'PUT', headers: {'Content-Type':'application/json', 'Authorization': `Bearer ${tok}`}, body: JSON.stringify({ name: newListTitle }) }); if (res.ok) { setNewListTitle(''); setModalType(null); await fetchWatchlists(); } };
  const handleDeleteList = async () => { if(!window.confirm(t('watchlist.alert_delete_folder'))) return; const tok = localStorage.getItem('token'); await fetch(`/api/watchlist/${activeListId}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${tok}` } }); setActiveListId(null); fetchWatchlists(); };
  const handleAddItem = async (e) => { e.preventDefault(); const tok = localStorage.getItem('token'); await fetch(`/api/watchlist/${activeListId}/add`, { method: 'POST', headers: {'Content-Type':'application/json', 'Authorization': `Bearer ${tok}`}, body: JSON.stringify({ symbol: newItemSymbol.toUpperCase() }) }); setNewItemSymbol(''); setModalType(null); fetchListItems(activeListId); };
  const handleDeleteItem = async (symbol) => { if(!window.confirm(`${t('watchlist.alert_remove_stock')} ${symbol} ?`)) return; const tok = localStorage.getItem('token'); await fetch(`/api/watchlist/${activeListId}/item/${symbol}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${tok}` } }); fetchListItems(activeListId); };
  const handleMoveItem = async (e) => { e.preventDefault(); const tok = localStorage.getItem('token'); await fetch(`/api/watchlist/${activeListId}/move`, { method: 'POST', headers: {'Content-Type':'application/json', 'Authorization': `Bearer ${tok}`}, body: JSON.stringify({ symbol: selectedSymbol, target_watchlist_id: parseInt(targetListId) }) }); setModalType(null); fetchListItems(activeListId); };
  
  const handleBuyItem = async (e) => { 
      e.preventDefault(); 
      const tok = localStorage.getItem('token'); 
      const dateTime = `${buyForm.date}T${buyForm.time}:00`;
      await fetch(`/api/portfolio/${buyForm.portfolio_id}/transaction`, { 
          method: 'POST', 
          headers: {'Content-Type':'application/json', 'Authorization': `Bearer ${tok}`}, 
          body: JSON.stringify({ 
              symbol: selectedSymbol, type: 'BUY', 
              quantity: parseFloat(buyForm.quantity), price: parseFloat(buyForm.price), 
              currency: buyForm.currency, commission: parseFloat(buyForm.commission || 0), 
              date: dateTime, notes: buyForm.notes 
          }) 
      }); 
      setModalType(null); alert(t('watchlist.alert_buy_success'));
  };

  const openRenameModal = () => { const currentList = watchlists.find(l => l.id === activeListId); if(currentList) { setNewListTitle(currentList.name); setModalType('RENAME_LIST'); } };
  const openBuyModal = (item) => {
      setSelectedSymbol(item.symbol);
      const now = new Date();
      setBuyForm({ ...buyForm, price: item.price > 0 ? item.price : '', currency: 'USD', commission: 0, date: now.toISOString().split('T')[0], time: now.toLocaleTimeString('en-GB', {hour:'2-digit', minute:'2-digit'}), notes: '' });
      setModalType('BUY');
  };

  if (loading) return <div className="min-h-screen pt-24 flex items-center justify-center font-bold text-slate-400">Chargement...</div>;

  return (
    <div className="min-h-screen bg-slate-50 pt-24 pb-12 font-sans text-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
          <div>
            <h1 className="title-page flex items-center gap-3">
              <Star className="text-yellow-400 fill-yellow-400" size={32} /> {t('watchlist.title')}
            </h1>
            <p className="subtitle mt-1">{t('watchlist.subtitle')}</p>
          </div>
          <a href="/screener" className="btn-primary flex items-center gap-2"><Search size={18}/> {t('watchlist.btn_find')}</a>
        </div>

        <div className="mb-8 overflow-x-auto no-scrollbar pb-2">
            <div className="flex items-center gap-2">
                {watchlists.map(list => (
                    <button key={list.id} onClick={() => setActiveListId(list.id)} className={`px-5 py-2.5 rounded-full text-sm font-bold whitespace-nowrap transition-all flex items-center gap-2 border ${activeListId === list.id ? 'bg-slate-900 text-white border-slate-900 shadow-md' : 'bg-white text-slate-500 border-slate-200 hover:bg-slate-100'}`}>
                        <Folder size={14} className={activeListId === list.id ? "text-white/50" : ""} /> {list.name}
                    </button>
                ))}
                
                {/* BOUTON CREATION DOSSIER (Avec indication PRO) */}
                <button onClick={handleCreateListClick} className="ml-2 px-4 py-2.5 rounded-full bg-white border border-dashed border-slate-300 text-slate-400 text-sm font-bold hover:border-slate-400 hover:text-slate-600 transition-all flex items-center gap-1 whitespace-nowrap">
                    {(!isProUser && watchlists.length >= 1) ? (
                        <><Crown size={14} className="text-amber-500"/> Débloquer Dossiers (PRO)</>
                    ) : (
                        <><Plus size={16}/> {t('watchlist.btn_new_folder')}</>
                    )}
                </button>
            </div>
        </div>

        {activeListId ? (
            <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
              
                <div className="flex justify-between items-center bg-white p-4 rounded-2xl border border-slate-200 shadow-sm">
                    <div className="flex items-center gap-2">
                        <span className="bg-slate-100 text-slate-700 px-3 py-1 rounded-lg text-xs font-bold uppercase tracking-wider">{watchlists.find(l=>l.id===activeListId)?.name}</span>
                        <span className="text-slate-400 text-xs font-bold ml-2">{items.length} {t('watchlist.assets_count')}</span>
                        <button onClick={openRenameModal} className="btn-icon" title="Renommer"><Edit2 size={14}/></button>
                    </div>
                    <div className="flex gap-2">
                        <button onClick={() => setModalType('ADD_ITEM')} className="btn-primary text-xs flex items-center gap-2"><Plus size={14}/> {t('watchlist.btn_add')}</button>
                        <button onClick={handleDeleteList} className="btn-danger p-2" title="Supprimer le dossier"><Trash2 size={16}/></button>
                    </div>
                </div>

                {loadingItems ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 animate-pulse">
                        {[1,2,3].map(i => <div key={i} className="h-48 bg-slate-200 rounded-2xl"></div>)}
                    </div>
                ) : items.length === 0 ? (
                    <div className="flex flex-col items-center justify-center py-20 bg-white rounded-3xl border border-dashed border-slate-200">
                        <div className="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center mb-4 text-slate-300"><Search size={32}/></div>
                        <p className="text-slate-500 font-medium mb-4">{t('watchlist.empty_folder')}</p>
                        <button onClick={() => setModalType('ADD_ITEM')} className="text-indigo-600 font-bold hover:underline">{t('watchlist.add_now')}</button>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                        {items.map((item, index) => (
                            <div key={index} className="card-panel hover:shadow-md hover:border-indigo-100 transition-all group relative flex flex-col justify-between">
                                <div className="flex justify-between items-start mb-4">
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 bg-white border border-slate-100 rounded-lg flex items-center justify-center p-1 shadow-sm">
                                            <img src={`https://financialmodelingprep.com/image-stock/${item.symbol}.png`} alt={item.symbol} className="w-full h-full object-contain" onError={(e) => e.target.style.display = 'none'} />
                                        </div>
                                        <div>
                                            <button onClick={() => openStockModal(item.symbol)} className="font-black text-lg text-slate-900 hover:text-indigo-600 transition-colors block leading-tight text-left">{item.symbol}</button>
                                            <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wide truncate max-w-[150px] block">{item.name || t('watchlist.stock')}</span> 
                                        </div>
                                    </div>
                                    <div className="flex gap-1">
                                        <button onClick={() => { setSelectedSymbol(item.symbol); setModalType('MOVE_ITEM'); }} className="btn-icon hover:text-indigo-600" title="Déplacer"><ArrowRightLeft size={16} /></button>
                                        <button onClick={() => handleDeleteItem(item.symbol)} className="btn-icon hover:text-red-600"><X size={16} /></button>
                                    </div>
                                </div>

                                <div className="flex items-center gap-4 mb-4">
                                    {safeVal(item.price) > 0 ? (
                                        <>
                                            <span className="text-2xl font-black text-slate-900">${safeVal(item.price).toFixed(2)}</span>
                                            <div className="flex flex-col gap-1.5">
                                                <span className={`flex items-center text-xs font-bold px-1.5 py-0.5 rounded w-fit ${safeVal(item.change) >= 0 ? 'bg-emerald-100 text-emerald-700' : 'bg-rose-100 text-rose-700'}`}>
                                                    {safeVal(item.change) > 0 ? <ArrowUpRight size={12}/> : <ArrowDownRight size={12}/>}
                                                    {Math.abs(safeVal(item.change)).toFixed(2)}%
                                                </span>
                                                {/* BADGE RSI */}
                                                {item.rsi !== null && (
                                                    <span className={`flex items-center gap-1 text-[10px] font-black px-1.5 py-0.5 rounded w-fit ${item.rsi < 30 ? 'bg-emerald-500 text-white shadow-sm' : item.rsi > 70 ? 'bg-rose-500 text-white shadow-sm' : 'bg-slate-100 text-slate-500'}`}>
                                                        <Activity size={10} /> RSI {item.rsi.toFixed(0)}
                                                    </span>
                                                )}
                                            </div>
                                        </>
                                    ) : (
                                        <div className="flex items-center gap-2">
                                            <span className="text-2xl font-black text-slate-300">--.--</span>
                                            <span className="text-[10px] bg-slate-100 text-slate-400 px-2 py-1 rounded-full font-bold">N/A</span>
                                        </div>
                                    )}
                                </div>

                                <div className="flex gap-2 mt-auto pt-4 border-t border-slate-50">
                                    <button onClick={() => openStockModal(item.symbol)} className="btn-secondary flex-1 flex justify-center items-center gap-1 text-xs"><Activity size={14}/> {t('watchlist.btn_analysis')}</button>
                                    <button onClick={() => openBuyModal(item)} className="btn-primary flex-1 flex justify-center items-center gap-1 text-xs"><ShoppingCart size={14}/> {t('watchlist.btn_buy')}</button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        ) : (
            <div className="flex flex-col items-center justify-center h-64 bg-slate-100 rounded-3xl border border-dashed border-slate-300 text-slate-400">
                <FolderPlus size={48} className="mb-4 opacity-50"/>
                <p className="font-bold">{t('watchlist.welcome_title')}</p>
                <button onClick={handleCreateListClick} className="mt-4 btn-secondary">
                     {(!isProUser && watchlists.length >= 1) ? <><Crown size={14} className="mr-1 text-amber-500 inline"/> Débloquer Dossiers (PRO)</> : t('watchlist.btn_create_folder')}
                </button>
            </div>
        )}

        {/* MODALES */}
        {(modalType === 'CREATE_LIST' || modalType === 'RENAME_LIST') && (
            <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[100] backdrop-blur-sm p-4">
                <div className="bg-white rounded-2xl p-6 w-full max-w-sm animate-in fade-in zoom-in duration-200">
                    <div className="flex justify-between items-center mb-4">
                        <h3 className="font-bold text-lg">{modalType === 'CREATE_LIST' ? t('watchlist.modal_new_folder') : t('watchlist.modal_rename_folder')}</h3>
                        <button onClick={()=>setModalType(null)} className="text-slate-400 hover:text-slate-600"><X size={20}/></button>
                    </div>
                    <form onSubmit={modalType === 'CREATE_LIST' ? handleCreateList : handleRenameList} className="space-y-4">
                        <input autoFocus type="text" placeholder={t('watchlist.placeholder_name')} className="input-field" value={newListTitle} onChange={e=>setNewListTitle(e.target.value)} required />
                        <button className="btn-primary w-full">{modalType === 'CREATE_LIST' ? t('watchlist.btn_create') : t('watchlist.btn_save')}</button>
                    </form>
                </div>
            </div>
        )}

        {modalType === 'ADD_ITEM' && (
            <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[100] backdrop-blur-sm p-4">
                <div className="bg-white rounded-2xl p-6 w-full max-w-sm animate-in fade-in zoom-in duration-200">
                    <div className="flex justify-between items-center mb-4"><h3 className="font-bold text-lg">{t('watchlist.modal_add_stock')}</h3><button onClick={()=>setModalType(null)} className="text-slate-400 hover:text-slate-600"><X size={20}/></button></div>
                    <form onSubmit={handleAddItem} className="space-y-4">
                        <input autoFocus type="text" placeholder={t('watchlist.placeholder_symbol')} className="input-field uppercase" value={newItemSymbol} onChange={e=>setNewItemSymbol(e.target.value)} required />
                        <button className="btn-primary w-full">{t('watchlist.btn_add')}</button>
                    </form>
                </div>
            </div>
        )}

        {modalType === 'MOVE_ITEM' && (
            <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[100] backdrop-blur-sm p-4">
                <div className="bg-white rounded-2xl p-6 w-full max-w-sm animate-in fade-in zoom-in duration-200">
                    <div className="flex justify-between items-center mb-4"><h3 className="font-bold text-lg">{t('watchlist.modal_move_stock')} {selectedSymbol}</h3><button onClick={()=>setModalType(null)} className="text-slate-400 hover:text-slate-600"><X size={20}/></button></div>
                    <form onSubmit={handleMoveItem} className="space-y-4">
                        <label className="label-field">{t('watchlist.move_to')}</label>
                        <select className="input-field" value={targetListId} onChange={e=>setTargetListId(e.target.value)} required>
                            <option value="">{t('watchlist.move_choose')}</option>
                            {watchlists.filter(w => w.id !== activeListId).map(w => <option key={w.id} value={w.id}>{w.name}</option>)}
                        </select>
                        <button className="btn-primary w-full">{t('watchlist.btn_move')}</button>
                    </form>
                </div>
            </div>
        )}

        {modalType === 'BUY' && (
            <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[100] backdrop-blur-sm p-4">
                <div className="bg-white rounded-2xl p-6 w-full max-w-md animate-in fade-in zoom-in duration-200">
                    <div className="flex justify-between items-center mb-4"><h3 className="font-bold text-lg">{t('watchlist.modal_buy_stock')} {selectedSymbol}</h3><button onClick={()=>setModalType(null)} className="text-slate-400 hover:text-slate-600"><X size={20}/></button></div>
                    
                    <form onSubmit={handleBuyItem} className="space-y-4">
                        <div>
                            <label className="label-field">{t('watchlist.buy_to_portfolio')}</label>
                            <select className="input-field" value={buyForm.portfolio_id} onChange={e=>setBuyForm({...buyForm, portfolio_id: e.target.value})} required>
                                <option value="">{t('watchlist.move_choose')}</option>
                                {portfolios.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
                            </select>
                        </div>

                        <div className="grid grid-cols-2 gap-3">
                            <div><label className="label-field">{t('watchlist.buy_qty')}</label><input type="number" className="input-field" value={buyForm.quantity} onChange={e=>setBuyForm({...buyForm, quantity: e.target.value})} required /></div>
                            <div><label className="label-field">{t('watchlist.buy_price')}</label><input type="number" step="any" className="input-field" value={buyForm.price} onChange={e=>setBuyForm({...buyForm, price: e.target.value})} required /></div>
                        </div>

                        <div className="grid grid-cols-2 gap-3">
                            <div>
                                <label className="label-field">{t('watchlist.buy_currency')}</label>
                                <select className="input-field" value={buyForm.currency} onChange={e=>setBuyForm({...buyForm, currency: e.target.value})}>
                                    <option value="USD">USD ($)</option><option value="EUR">EUR (€)</option><option value="GBP">GBP (£)</option>
                                </select>
                            </div>
                            <div>
                                <label className="label-field">{t('watchlist.buy_commission')}</label>
                                <div className="relative">
                                    <input type="number" step="any" className="input-field pl-8" value={buyForm.commission} onChange={e=>setBuyForm({...buyForm, commission: e.target.value})} />
                                    <DollarSign size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"/>
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-2 gap-3">
                            <div><label className="label-field">{t('watchlist.buy_date')}</label><input type="date" className="input-field" value={buyForm.date} onChange={e=>setBuyForm({...buyForm, date: e.target.value})} required /></div>
                            <div><label className="label-field">{t('watchlist.buy_time')}</label><input type="time" className="input-field" value={buyForm.time} onChange={e=>setBuyForm({...buyForm, time: e.target.value})} required /></div>
                        </div>

                        <div>
                            <label className="label-field">{t('watchlist.buy_notes')}</label>
                            <textarea rows="2" className="input-field" placeholder={t('watchlist.buy_notes_placeholder')} value={buyForm.notes} onChange={e=>setBuyForm({...buyForm, notes: e.target.value})}></textarea>
                        </div>

                        <button className="btn-primary w-full bg-emerald-600 hover:bg-emerald-700 shadow-emerald-200">{t('watchlist.btn_confirm_buy')}</button>
                    </form>
                </div>
            </div>
        )}

      </div>
    </div>
  );
};

export default WatchlistPage;
